export const LIBRARY = 'LIBRARY_LIBRARY'
export const ALL_LIBRARY = 'ALL_LIBRARY'
export const LOADING = 'LIBRARY_LOADING'
export const UPLOAD_FILE_STATUS = 'LIBRARY_UPLOAD_FILE_STATUS'
export const LIBRARY_UPLOAD_PERCENT = 'LIBRARY_UPLOAD_PERCENT'
export const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
export const SET_FOLDER_TITLE = 'SET_FOLDER_TITLE'
export const RESET_TITLE = 'RESET_TITLE'
export const SET_OVERLAY_SHOWING = 'SET_OVERLAY_SHOWING'
export const SET_FILE_OVERLAY_SHOWING = 'SET_FILE_OVERLAY_SHOWING'
export const SET_PARENT_ID = 'SET_PARENT_ID'
export const SET_CURRENT_TAB = 'SET_CURRENT_TAB'
export const SET_FILE_SCOPE = 'SET_FILE_SCOPE'
export const SET_SELECTED_ORG_GROUPS = 'SET_SELECTED_ORG_GROUPS'
export const SET_LIBRARY_ISLOADING = 'SET_LIBRARY_ISLOADING'
export const SET_FILES_PARENTS = 'SET_FILES_PARENTS'
export const SET_PARENT_NAME = 'SET_PARENT_NAME'
export const SET_PARENT = 'SET_PARENT'
export const SET_CURRENT_SELECTED_ITEMS = 'SET_CURRENT_SELECTED_ITEMS'
export const SET_CURRENT_ITEMS = 'SET_CURRENT_ITEMS'
export const SET_CURRENT_TOGGLE_ITEM_FUNCTION =
  'SET_CURRENT_TOGGLE_ITEM_FUNCTION'
export const SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION =
  'SET_CURRENT_HIDE_SELECTED_ITEMS_FUNCTION'
export const SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION =
  'SET_CURRENT_SHOW_SELECTED_ITEMS_FUNCTION'
export const SET_SELECTED_USERS = 'SET_SELECTED_USERS'
export const SET_SELECTED_LOCATION_GROUPS = 'SET_SELECTED_LOCATION_GROUPS'
export const SET_SELECTED_ROLE_GROUPS = 'SET_SELECTED_ROLE_GROUPS'
export const SET_SELECTED_LOCATIONS = 'SET_SELECTED_LOCATIONS'
export const SET_SELECTED_STORES = 'SET_SELECTED_STORES'
export const SET_SELECTED_ROLES = 'SET_SELECTED_ROLES'
export const RESET_SELECTED_ITEMS = 'RESET_SELECTED_ITEMS'
export const SET_ASSIGN_SEARCH_VALUE = 'SET_ASSIGN_SEARCH_VALUE'
export const SET_SHOW_SELECTED_ORG_GROUPS = 'SET_SHOW_SELECTED_ORG_GROUPS'
export const SET_SHOW_SELECTED_USERS = 'SET_SHOW_SELECTED_USERS'
export const SET_SHOW_SELECTED_LOCATIONS = 'SET_SHOW_SELECTED_LOCATIONS'
export const SET_SHOW_SELECTED_STORES = 'SET_SHOW_SELECTED_STORES'
export const SET_SHOW_SELECTED_LOCATION_GROUPS =
  'SET_SHOW_SELECTED_LOCATION_GROUPS'
export const SET_SHOW_SELECTED_ROLE_GROUPS = 'SET_SHOW_SELECTED_ROLE_GROUPS'
export const SET_SHOW_SELECTED_ROLES = 'SET_SHOW_SELECTED_ROLES'
export const SET_CURRENT_SHOW_SELECTED_ITEMS = 'SET_CURRENT_SHOW_SELECTED_ITEMS'
export const SET_SEARCH_VALUE_ON_CLICK = 'SET_SEARCH_VALUE_ON_CLICK'
export const SET_HOMEWORK_TITLE = 'SET_HOMEWORK_TITLE'
export const SET_MY_DOCUMENTS = 'SET_MY_DOCUMENTS'
export const SELECT_FOLDER = 'SELECT_FOLDER'
export const FETCH_ALL_FOLDERS = 'FETCH_ALL_FOLDERS'
export const FETCH_ALL_FOLDERS_NESTED = 'FETCH_ALL_FOLDERS_NESTED'
export const SET_ITEM_INDEX = 'SET_ITEM_INDEX'
export const UNDO = 'UNDO'
export const PRESENT = 'PRESENT'
export const TOGGLE_LIBRARY = 'TOGGLE_LIBRARY'
export const SET_ROLE_SELECTED = 'SET_ROLE_SELECTED'
export const SET_LIBRARY_FOLDER_ROLES = 'SET_LIBRARY_FOLDER_ROLES'
export const ON_CHANGE = 'ON_CHANGE'
export const SET_FILTERED_FILES_IDS = 'SET_FILTERED_FILES_IDS'
export const UPSERT_LIBRARY_ITEMS = 'UPSERT_LIBRARY_ITEMS'
export const REMOVE_LIBRARY_ITEM = 'REMOVE_LIBRARY_ITEM'
